/* eslint-disable */

import React, { useState, useEffect } from 'react'
import waTemplateSvc from 'services/waTemplateSvc';
import applicationSvc from "services/applicationSvc";

import Image from '_assets/images/template/ic-image.svg';
import Document from '_assets/images/template/ic-document.svg';
import Video from '_assets/images/template/ic-video.svg';
import Location from '../../_assets/svg/location.svg';
import Phone from '../../_assets/svg/phone.svg';
import ExLink from '../../_assets/svg/external-link.svg';
import HelpCircle from '../../_assets/svg/help-circle.svg';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import FeatherIcon from 'feather-icons-react';

function PhoneMediaPreview(props) {
  const [isMasking, setMasking] = useState("");
  const { previewData, className } = props;
  let preview = previewData;
  let masking = "OCA Indonesia";

  function convert(message) {
    if (message) {
      return message
        .replace(/(?:\*)((?:(?!\*|\n).)+)(?:\*)/g, '<b>$1</b>')
        .replace(/(?:_)((?:(?!\n|_).)+)(?:_)/g, '<i>$1</i>');
      // .replace(/(?:~)(?:(?!\s))((?:(?!\n|~).)+)(?:~)/g,'<s>$1</s>')
      // .replace(/(?:--)(?:(?!\s))((?:(?!\n|--).)+)(?:--)/g,'<u>$1</u>')
      // .replace(/(?:```)(?:(?!\s))((?:(?!\n|```).)+)(?:```)/g,'<tt>$1</tt>');
    }
  }

  async function handleMaskingWa() {
    await applicationSvc.getAll().then((response) => {
      console.log(response.data.data[0]._id);
      waTemplateSvc.getMaskingWa(response.data.data[0]._id).then((res) => {
        setMasking(res.data.data.whatsapp.senderName)
      })
        .catch((error) => {
          console.log(error)
        })
    }).catch(() => { });

  }

  function checkReg(str) {
    if (typeof str !== 'undefined') {
      let string = str
      string = string.replace(/_(.*?)_/g, `<i>$1</i>`)
      string = string.replace(/~(.*?)~/g, `<del>$1</del>`)
      string = string.replace(/```(.*?)```/g, `<tt>$1</tt>`)
      string = string.replace(/\*(.*?)\*/g, `<b>$1</b>`)
      string = string.replace(/(\r\n|\n|\r)/gm, "<br />");
      return { __html: string };
    }

    return { __html: str };
  }

  useEffect(() => {
    setMasking("OCA Indonesia")
    handleMaskingWa()
    if (previewData?.header) {
      // setPreviewData(previewData)
    }
  }, [])
  return (
    <div className={`phone-middle  ${className}`}>
      <div className="phone-preview mx-lg-3">
        <div className="head-name">
          {isMasking &&
            <span className="inisial h6">{isMasking[0]}</span>
          }
          <span className="ms-2">{isMasking}</span>
        </div>
        <div className="preview-text custom-scrollbar p-3">
          <div className="mb-2">
            <div className={`${previewData?.message ? '' : 'd-none'} sms-text`}>
              <div className={`${previewData?.header?.type && previewData?.header?.type != 'text' && previewData?.header?.type != 'none' ? '' : 'd-none'} picture_template mb-2`}>
                <OverlayTrigger
                  placement="left"
                  overlay={
                  <Tooltip id="button-tooltip-2">
                    The media (images, videos, documents, and locations) shown is only a preview. The media that will be received by the recipient of the message is the media that you have attached at the time of submitting the template.
                  </Tooltip>}
                >
                  <span className='d-flex tooltip_preview_template'>
                    <FeatherIcon icon="info" className="cursor-pointer cl-white ms-2" />
                  </span>
                </OverlayTrigger>
                <img className={`${previewData?.header?.type == 'image' ? '' : 'd-none'} icon w-100`} src={Image} alt="" />
                <img className={`${previewData?.header?.type == 'document' ? '' : 'd-none'} icon w-100`} src={Document} alt="" />
                <img className={`${previewData?.header?.type == 'video' ? '' : 'd-none'} icon w-100`} src={Video} alt="" />
                <img className={`${previewData?.header?.type == 'location' ? '' : 'd-none'} icon w-100`} src={Location} alt="" />
              </div>
              <h6 className={`${previewData?.header?.text} preview-header mb-2 text-xs font-semibold`}>{previewData?.header?.text}</h6>
              <div className="mb-0 pre-wrap" dangerouslySetInnerHTML={checkReg(previewData?.message)} />
              {/* <div className="mb-0 pre-wrap">{convert(previewData?.message)}</div> */}
            </div>
            <div className={`${previewData?.footer?.length > 0 ? '' : 'd-none'} d-flex button-wrap flex-wrap`}>
              {previewData?.footer?.map((val, index) => {
                return <button key={index} className="btn add-btn mt-1 mx-1">
                  <img width="16" height="16" className={`${val.type === 'phone' ? '' : 'd-none'} mr-2`} src={Phone} alt="" />
                  <img width="16" height="16" className={`${val.type === 'link' ? '' : 'd-none'} mr-2`} src={ExLink} alt="" />
                  {val?.display}
                </button>
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PhoneMediaPreview